<template>
<div v-if="true" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="fixed inset-0 dark:bg-gray-600 dark:bg-opacity-50 bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
    <div class="inline-block align-bottom bg-white dark:bg-gray-900 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-1/2">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 group h-auto dark:bg-gray-900">
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h2 class="text-xl leading-6 font-medium text-gray-900 dark:text-gray-300" id="modal-title">
              Editar dados da loja
            </h2>
            <form class="flex flex-row flex-wrap mx-auto w-full my-8 gap-y-4 gap-x-2" @submit.prevent="createLoja()">
              <p class="w-full font-bold text-gray-600 dark:text-gray-200">Dados Jurídicos</p>
              <span class="w-1/2">
                  <Input label="CNPJ" type="text" v-model="cnpj" v-maska="'##.###.###/####-##'" :validation="v$.cnpj"/>
              </span>
              <span class="flex-1">
                  <Select label="Faturamento" desc="descricao" type="text" v-model="faturamento_id" :list="listFaturamentos" :validation="v$.faturamento_id"/>
              </span>
              <Input label="Razão Social" type="text" v-model="razao" :validation="v$.razao"/>
              <Input label="Nome Fantasia" type="text" v-model="nome" :validation="v$.nome"/>

              <p class="w-full font-bold text-gray-600 dark:text-gray-200">Características</p>
              <span class="w-1/3">
                  <Select label="Segmento" desc="descricao" type="text" v-model="segmento_id" :list="listSegmentos" :validation="v$.segmento_id" :disabled="userRole !== 'administrador'"/>
              </span>

              <p class="w-full font-bold text-gray-600 dark:text-gray-200">Contatos</p>
              <Input label="Email" type="text" v-model="email" :validation="v$.email"/>
              <span class="w-1/3">
                  <Input label="Telefone 1" type="text" v-model="telefone1" v-maska="['(##) # ####-####', '(##) ####-####']" :validation="v$.telefone1"/>
              </span>
              <span class="w-1/3">
                  <Input label="Telefone 2" type="text" v-model="telefone2" v-maska="['(##) # ####-####', '(##) ####-####']" :validation="v$.telefone2"/>
              </span>
              <span class="flex-1">
                  <Input label="Nome do Contato" type="text" v-model="nome_contato" :validation="v$.nome_contato"/>
              </span>

              <p class="w-full font-bold text-gray-600 dark:text-gray-200">Endereço</p>
              <span class="w-full">
                  <Input label="Endereço" type="text" v-model="endereco.endereco" :validation="v$.endereco.endereco"/>
              </span>
              <span class="w-10/12">
                  <Input label="Complemento" type="text" v-model="endereco.complemento" :validation="v$.endereco.complemento"/>
              </span>
              <span class="flex-1">
                  <Input label="Nº" type="text" v-model="endereco.numero" :validation="v$.endereco.numero"/>
              </span>
              <span class="w-full">
                  <Input label="Bairro" type="text" v-model="endereco.bairro" :validation="v$.endereco.bairro"/>
              </span>
              <span class="flex-1">
                  <Input label="Cidade" type="text" v-model="endereco.cidade" :validation="v$.endereco.cidade"/>
              </span>
              <span class="w-1/12">
                  <Select label="UF" type="text" v-model="endereco.uf_id" :list="listUFS" desc="descricao" :validation="v$.endereco.uf_id"/>
              </span>
              <span class="w-1/4">
                  <Input label="CEP" type="text" v-model="endereco.cep" v-maska="'##.###-###'" :validation="v$.endereco.cep"/>
              </span>
            </form>
          </div>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse dark:bg-gray-900">
        <button @click="updateLoja" type="button" class="btn w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" :disabled="loading">
          <span v-if="loading" class="w-auto h-full">
            <Spinner width="3"/>
          </span>
          <span v-else>Salvar</span>
        </button>
        <button @click="$emit('changeVisibility')" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { reactive, ref } from '@vue/reactivity'
import Autocomplete from '../Design/Autocomplete.vue'
import Spinner from '../Design/Spinner.vue'
import Input from '@/components/Design/Input'
import Select from '@/components/Design/Select'
import { GET_FATURAMENTOS, GET_SEGMENTOS, PUT_ATIVA } from '../../mixins/api'
import { requiredOnly, nomeFantasia, phone, phone2, emailValidator, cnpjValidator, enderecoValidator, personNameNotRequired } from '@/mixins/validators.js'
import useVuelidate from '@vuelidate/core'
import { findId } from '../../mixins/findData'
import { displayNotification } from '../../mixins/notification'
import { useStore } from 'vuex'

export default {
    name: 'PesquisadorModal',
    components: {
        Autocomplete,
        Spinner,
        Input,
        Select
    },
    props: ['loja'],
    setup (props, { emit }) {
        const loading = ref(false)
        const store = useStore()
        const userRole = ref('')
        userRole.value = store.getters['auth/user'].role

        console.log(userRole.value)
        const cnpj = ref(props.loja.cnpj)
        const razao = ref(props.loja.razao_social)
        const nome = ref(props.loja.nome_fantasia)
        const nome_contato = ref(props.loja.nome_contato)
        const segmento_id = ref(props.loja.segmento)
        const faturamento_id = ref(props.loja.faturamento)
        const telefone1 = ref(props.loja.telefone1)
        const telefone2 = ref(props.loja.telefone2)
        const email = ref(props.loja.email)
        const endereco = reactive({
            bairro: props.loja.endereco.bairro,
            cep: props.loja.endereco.cep,
            cidade: props.loja.endereco.cidade,
            complemento: props.loja.endereco.complemento,
            endereco: props.loja.endereco.endereco,
            numero: props.loja.endereco.numero,
            uf_id: props.loja.endereco.uf_id
        })
        const listFaturamentos = ref([])
        const listSegmentos = ref([])
        const listUFS = ref([])
        const getLists = async () => {
            await GET_FATURAMENTOS().then(r => {
                listFaturamentos.value = r.data
            })
            await GET_SEGMENTOS().then(r => {
                listSegmentos.value = r.data
            })
        }
        getLists()

        const updateLoja = async () => {
            await v$.value.$validate()
            
            if (!v$.value.$error) {
                loading.value = true
                const body = {
                    cnpj: cnpj.value.replaceAll('.', '').replace('/', '').replace('-', ''),
                    razao_social: razao.value,
                    nome_fantasia: nome.value,
                    nome_contato: nome_contato.value,
                    segmento_id: findId(listSegmentos.value, segmento_id.value, 'descricao'),
                    faturamento_id: findId(listFaturamentos.value, faturamento_id.value, 'descricao'),
                    telefone1: telefone1.value.replace('(', '').replace(')', '').replace('-', '').replace(' ', '').replace(' ', ''),
                    telefone2: telefone2.value ? telefone2.value.replace('(', '').replace(')', '').replace('-', '').replace(' ', '').replace(' ', '') : '',
                    email: email.value,
                    bairro: endereco.bairro,
                    cep: endereco.cep.replace('.', '').replace('-', ''),
                    cidade: endereco.cidade,
                    complemento: endereco.complemento,
                    endereco: endereco.endereco,
                    numero: endereco.numero,
                    uf_id: endereco.uf_id

                }
                await PUT_ATIVA(props.loja.id, body).then(r => {
                    displayNotification(r)
                    emit('close')
                }).catch(e => {
                    displayNotification(e.response)
                }).finally(() => {
                    loading.value = false
                })
            }
        }

        const rules = {
            cnpj: cnpjValidator(),
            razao: requiredOnly(),
            nome: nomeFantasia(),
            nome_contato: personNameNotRequired(),
            segmento_id: requiredOnly(),
            faturamento_id: requiredOnly(),
            telefone1: phone(),
            telefone2: phone2(),
            email: emailValidator(),
            endereco: enderecoValidator()
        }
        const v$ = useVuelidate(rules, { cnpj, razao, nome, nome_contato, segmento_id, faturamento_id, telefone1, telefone2, email, endereco })
        return {
            cnpj,
            razao,
            nome,
            nome_contato,
            segmento_id,
            faturamento_id,
            telefone1,
            telefone2,
            email,
            endereco,

            listFaturamentos,
            listSegmentos,
            updateLoja,
            loading,
            v$,
            userRole
        }
    }
}
</script>

<style scoped>

.fade-enter-from {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}

.fade-enter-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-from {
  opacity: 1;
}

.fade-leave-to {
  opacity: 0;
}

</style>
